module.exports = __webpack_public_path__ + "img/clock.34f76d65.svg";